import axios from '@src/utils/axios'

const axiosInstance = axios(false);

export default {
  'REGISTER': (ctx, data) => axiosInstance.post('/auth/register', data),
  'login': (ctx, data) => axiosInstance.post('/auth/login', data),
  'LOGOUT' ({ commit }){
    commit('SET_AUTH', null)
  },
  'SET_AUTH' ({ commit }, payload = {}){
    commit('SET_AUTH', payload)
  },
  'SET_MODULES' ({ commit }, payload = []){
    commit('SET_MODULES', payload)
  },
  'validate' ({ commit, state }){
    if (!state.user) return Promise.resolve(null)

    return axiosInstance.get('/auth/validate').then((res) => {
      let data = res.data
      commit('SET_AUTH', data)
      commit('SET_MODULES', data)
      return data
    }).catch(() => {
      /* if (error.response && error.response.status === 401) { */
        commit('SET_AUTH', null)
        commit('SET_MODULES', null)
        
      /* } */
      return null
    })
  }



  /* async login({
    commit
  }, user) {
    commit('auth_request')
    let res = await axiosInstance.post('users/login', user)
    if(res.data.success){
      const token = res.data.token
      const user = res.data.user
      //store token to localstorage
      localStorage.setItem('token', token)
      //set the axios default
      axiosInstance.defaults.headers.common['Authorization'] = token
      commit('auth_success', token, user)
    }
    return res
  },
  async register({
    commit
  }, user){
    commit('register_request')
    let res = await axiosInstance.post('users/register', user)
    if(res.data.success !== undefined){
      commit('register_success')
    }
    return res
  },
  async logout({
    commit
  }){
    await localStorage.removeItem('token')
    commit('logout')
    delete axiosInstance.defaults.headers.common['Authorization']
    router.push('/login')
    return  true
  },
  async getProfile({
    commit
  }){
    commit('profile_request')
    let res = await axiosInstance.get('users/profile')
    commit('user_profile', res.data.user)
    return res
  } */
}